<template>
  <div class="container">
    <!-- 导航条 -->
    <nav class="navbar">
      <button @click="goBack" class="back-button">←    返回上一页</button>
      <button  class="back-button" >视频正在加载，请稍等</button>
    </nav>
    
    <!-- iframe 嵌入第三方网页 -->
    <iframe 
      ref="iframeRef"
      :src="currentUrl"
      class="iframe-content"
      @load="updateHistory"
    ></iframe>
  </div>
</template>

<script setup>
import { ref, onMounted ,watchEffect} from 'vue';
// 导入路由相关功能（如果使用Vue Router）
import { useRouter,useRoute } from 'vue-router'
const route = useRoute() // 用于获取路由中参数
const router = useRouter()//用于导航

 // 返回上一页
    const goBack = () => {
      // 如果使用Vue Router
      router.back()
      // 如果不使用Vue Router，可以使用以下方法
      // window.history.back()
    }
// 默认网址列表
const defaultUrls = ref('');
watchEffect(() => {
  // 直接使用 route.query 来更新最终显示的数据
  //videoTitle.value = route.query.title || '默认标题';
  defaultUrls.value = route.query.videosrc || '';
console.log('路由中的值是：',defaultUrls.value)
});






// 当前显示的URL
const currentUrl = ref(defaultUrls.value);
// iframe引用
const iframeRef = ref(null);
// 历史记录栈
const historyStack = ref([defaultUrls.value]);
// 当前历史位置
const historyPosition = ref(0);



// 更新历史记录
const updateHistory = () => {
  // 不再尝试获取iframe的URL，只使用我们设置的currentUrl
  // 这样虽然不能跟踪iframe内部的重定向，但避免了跨域错误
  if (historyPosition.value < historyStack.value.length - 1) {
    historyStack.value = historyStack.value.slice(0, historyPosition.value + 1);
  }
  historyStack.value.push(currentUrl.value);
  historyPosition.value++;
};

// 初始化时加载默认URL
onMounted(() => {
  // 添加事件监听器，防止iframe内页面跳转时父页面也被跳转
  window.addEventListener('blur', () => {
    if (document.activeElement === iframeRef.value) {
      // iframe获得焦点，可以在这里处理一些逻辑
    }
  });
});
</script>

<style>
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
}

.navbar {
  align-items: center; /* 垂直方向居中 */
  justify-content: center; /* 新增：水平方向居中 */
  display: flex;
  flex-direction: column; /* 垂直排列 */
  gap: 10px; /* 可选：设置按钮之间的间距 */
  padding: 10px 20px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.back-button {
  padding: 5px 10px;
  margin-right: 15px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: block
}

.back-button:hover {
  background-color: #45a049;
}

.url-display {
  flex-grow: 1;
  padding: 5px 10px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iframe-content {
  flex-grow: 1;
  width: 100%;
  border: none;
}
</style>